<template>
  <div class="col-12">
    <div class="row" style="max-width: 95%; margin: auto">
      <div
        class="
          col-12
          d-flex
          justify-content-center justify-content-sm-between
          flex-wrap
        "
      >
        <h4 class="card-title text-purple">
          {{ $t("app.modules.customer_information_change.title") }}
        </h4>
      </div>

      <card
        card-body-classes="table-full-width"
        style="box-shadow: initial"
        no-footer-line
      >
        <div style="max-width: 80%; margin: auto; padding-top: 20px">
          <card>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(submit)">
                <div class="row">
                  <div class="col-6">
                    <fg-input
                      type="text"
                      :label="$t('app.profile.contact.email')"
                      :placeholder="$t('app.profile.contact.email')"
                      class="profile-label"
                      disabled
                      :value="item.email"
                    />
                  </div>
                  <div class="col-6">
                    <fg-input
                      type="text"
                      :label="$t('app.profile.contact.email')"
                      :placeholder="$t('app.profile.contact.email')"
                      class="profile-label"
                      v-model="item.emailModificado"
                    />

                    
                    
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <fg-input
                      type="text"
                      :label="$t('app.modules.customers.business_name')"
                      :placeholder="$t('app.modules.customers.business_name')"
                      class="profile-label"
                      v-model="item.razonSocialModificado"
                    />
                  </div>
                  <div class="col-6">
                    <fg-input
                      type="text"
                      :label="$t('app.profile.contact.cellphone')"
                      :placeholder="$t('app.profile.contact.cellphone')"
                      class="profile-label"
                      v-model="item.telefono"
                    />
                  </div>
                  
                </div>
                

                <div class="row">
                  <div class="col-12">
                    <h4 class="col-md-12 profile-label">
                      {{ $t("app.profile.fiscal_address.title") }}
                    </h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :label="'*' + $t('app.profile.fiscal_address.rfc')"
                        :error="
                          failed
                            ? $t(
                                'app.modules.customer_information_change.errors.required'
                              )
                            : null
                        "
                        :hasSuccess="passed"
                        :placeholder="$t('app.profile.fiscal_address.rfc')"
                        class="profile-label"
                        v-model="item.rfc"
                      />
                    </ValidationProvider>

                    <ValidationProvider
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :label="'*' + $t('app.profile.fiscal_address.street')"
                        :placeholder="$t('app.profile.fiscal_address.street')"
                        :error="
                          failed
                            ? $t(
                                'app.modules.customer_information_change.errors.required'
                              )
                            : null
                        "
                        :hasSuccess="passed"
                        class="profile-label"
                        v-model="item.calle"
                      />
                    </ValidationProvider>

                    <fg-input
                      type="text"
                      :label="$t('app.profile.fiscal_address.number')"
                      :placeholder="$t('app.profile.fiscal_address.number')"
                      class="profile-label"
                      v-model="item.numExterior"
                    />

                    <fg-input
                      type="text"
                      :label="$t('app.profile.fiscal_address.number_int')"
                      :placeholder="$t('app.profile.fiscal_address.number_int')"
                      class="profile-label"
                      v-model="item.numInterior"
                    />

                    <!--  

                    <ValidationProvider
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :label="'*'+$t('app.profile.fiscal_address.block')"
                        :placeholder="$t('app.profile.fiscal_address.block')"
                        :error="failed ? $t('app.modules.customer_information_change.errors.required') : null"
                        :hasSuccess="passed"
                        class="profile-label"
                        v-model="item.colonia"/>
                    </ValidationProvider>
                    -->

                    <ValidationProvider
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :label="'*' + $t('app.profile.fiscal_address.city')"
                        :placeholder="$t('app.profile.fiscal_address.city')"
                        :error="
                          failed
                            ? $t(
                                'app.modules.customer_information_change.errors.required'
                              )
                            : null
                        "
                        :hasSuccess="passed"
                        class="profile-label"
                        v-model="item.delegacionMunicipio"
                      />
                    </ValidationProvider>
                  </div>

                  <div class="col-6">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :label="'*' + $t('app.profile.fiscal_address.state')"
                        :placeholder="$t('app.profile.fiscal_address.state')"
                        :error="
                          failed
                            ? $t(
                                'app.modules.customer_information_change.errors.required'
                              )
                            : null
                        "
                        :hasSuccess="passed"
                        class="profile-label"
                        v-model="item.estado"
                      />
                    </ValidationProvider>

                    <fg-input
                      type="text"
                      :label="$t('app.profile.fiscal_address.country')"
                      :placeholder="$t('app.profile.fiscal_address.country')"
                      class="profile-label"
                      v-model="item.pais"
                    />

                    <ValidationProvider
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :label="$t('app.profile.fiscal_address.phone01')"
                        :placeholder="$t('app.profile.fiscal_address.phone01')"
                        :error="
                          failed
                            ? $t(
                                'app.modules.customer_information_change.errors.required'
                              )
                            : null
                        "
                        :hasSuccess="passed"
                        class="profile-label"
                        v-model="item.telefono1"
                      />
                    </ValidationProvider>

                    <fg-input
                      type="text"
                      :label="$t('app.profile.fiscal_address.phone02')"
                      :placeholder="$t('app.profile.fiscal_address.phone02')"
                      class="profile-label"
                      v-model="item.telefono2"
                    />

                    <ValidationProvider
                      rules="required"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        type="text"
                        :label="
                          '*' + $t('app.profile.fiscal_address.postal_code')
                        "
                        :placeholder="
                          $t('app.profile.fiscal_address.postal_code')
                        "
                        :error="
                          failed
                            ? $t(
                                'app.modules.customer_information_change.errors.required'
                              )
                            : null
                        "
                        :hasSuccess="passed"
                        class="profile-label"
                        v-model="item.codigoPostal"
                      />
                    </ValidationProvider>
                  </div>
                </div>
                <div
                  slot="footer"
                  style="
                    margin-top: 10px;
                    padding-top: 20px;
                    border-top: outset;
                  "
                  class="row"
                >
                  <div class="col-12" style="text-align: center">
                    <n-button
                      native-type="submit"
                      type="primary"
                      style="font-size: 1.2rem"
                      >{{ $t("app.general.send") }}</n-button
                    >
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </card>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { getResponse } from "@/util/utilities";
export default {
  components: {},
  computed: {},
  data() {
    return {
      item: {
        telefono: "",
        email: "",
        rfc: "",
        estado: "",
        calle: "",
        pais: "",
        numInterior: "",
        numExterior: "",
        colonia: "",
        codigoPostal: "",
        delegacionMunicipio: "",
        telefono1: "",
        telefono2: "",
        idCliente: "",
        nombre: "",
        razonSocial: "",
        emailModificado: "",
        razonSocialModificado: ""
      },
    };
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });

    await this.loadPerfil();

    this.$swal.close();
  },
  methods: {
    async loadPerfil() {
      let payload = {
        id: this.$store.state.user.idCliente,
        usuario: this.$store.state.user.idUsuario
      };

      let request = await this.$http.post(
        route("Clientes/getPerfilCliente"),
        payload
      );
      let response = getResponse(request, null);

      if (response) {
        this.item = response.perfil;
        if (this.item.emailModificado == ""){
          this.item.emailModificado = this.item.email;
        }
        if (this.item.razonSocialModificado == ""){
          this.item.razonSocialModificado = this.item.razonSocial;
        }

        //this.item.emailModificado = response.perfil.email;
      }
    },
    async submit() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      //this.item.idCliente = this.$store.state.user.idCliente;

      //console.log("Valor de item --> " + JSON.stringify(this.item))

      let request = await this.$http.post(
        route("SolicitudCambioCliente/addSolicitud"),
        this.item
      );
      let response = getResponse(request, null);

      if (response) {
        this.notifyMessage(
          "success",
          this.$t("app.modules.customer_information_change.messages.success")
        );
        this.$router.push({ name: "Home" });
      } else this.notifyMessage("danger", request.body.message);

      this.$swal.close();
    },
  },
};
</script>

<style scoped>
</style>
